export const DELETE_CUSTOMER_REQUEST = 'DELETE_CUSTOMER_REQUEST';
export const DELETE_CUSTOMER_SUCCESS = 'DELETE_CUSTOMER_SUCCESS';
export const DELETE_CUSTOMER_FAILURE = 'DELETE_CUSTOMER_FAILURE';
export const RESET_DELETE_CUSTOMER_STATE = 'RESET_DELETE_CUSTOMER_STATE';


export const deleteCustomerRequest = (id) => ({
    type: DELETE_CUSTOMER_REQUEST,
    payload: id,
});

export const deleteCustomerSuccess = (id) => ({
    type: DELETE_CUSTOMER_SUCCESS,
    payload: id,
});

export const deleteCustomerFailure = (error) => ({
    type: DELETE_CUSTOMER_FAILURE,
    payload: error,
});
